import {
  BzButton,
  BzCard,
  BzDatePicker,
  BzDivider,
  BzEmptyState,
  BzIcon,
  BzRadio,
  BzRadioGroup,
  BzSearchInput,
  BzSelect,
  BzSpinner,
  BzSwitch,
  BzTable,
  BzTableHeaderDef,
  BzTableRowDef,
  BzTag,
  BzTooltip
} from "@bringoz/ui";
import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {BringozTooltipComponent} from "./components/bringoz-tooltip/bringoz-tooltip.component";
import {NgbModule, NgbPaginationModule} from "@ng-bootstrap/ng-bootstrap";
import {BringozPhonePipe} from "./pipes/bringoz-phone.pipe";
import {TextCopyButtonComponent} from "./components/text-copy-button/text-copy-button.component";
import {BranchesIndicatorComponent} from "./components/branches-indicator/branches-indicator.component";
import {PermissionDirective} from "./directives/permission.directive";
import {TableColumnManagerDirective} from "./directives/table-column-manager.directive";
import {TableScrollSyncDirective} from "./directives/table-scroll-sync.directive";
import {
  TableHeaderDefDirective,
  TableRowDefDirective
} from "./directives/resizable-table-defs.directive";
import {BringozDataTableComponent} from "./components/bringoz-data-table/bringoz-data-table.component";
import {BringozButtonComponent} from "./components/bringoz-button/bringoz-button.component";
import {BringozIconComponent} from "./components/bringoz-icon/bringoz-icon.component";
import {AngularSvgIconModule} from "angular-svg-icon";
import {BringozSwitchComponent} from "./components/bringoz-switch/bringoz-switch.component";
import {BringozStatusTagComponent} from "./components/bringoz-status-tag/bringoz-status-tag.component";
import {TranslateModule} from "@ngx-translate/core";
import {
  BringozItemsListDisplayComponent
} from "./components/bringoz-items-list-display/bringoz-items-list-display.component";
import {BringozIdGeneratorDirective} from "./directives/bringoz-id-generator.directive";
import {BringozPricePipe} from "./pipes/bringoz-price.pipe";
import {CommonModule, CurrencyPipe} from "@angular/common";
import {BringozDistancePipe} from "./pipes/bringoz-distance.pipe";
import {BringozTemperaturePipe} from "./pipes/bringoz-temperature.pipe";
import {BringozTagsComponent} from "./components/bringoz-tags/bringoz-tags.component";
import {BringozTagComponent} from "./components/bringoz-tag/bringoz-tag.component";
import {UserNamePipe} from "./pipes/user-name.pipe";
import {SkillTagsComponent} from "./components/skill-tags/skill-tags.component";
import {
  BringozPackagesItemsDisplayListComponent
} from "./components/bringoz-packages-items-display-list/bringoz-packages-items-display-list.component";
import {PackagesIndicatorComponent} from "./components/packages-indicator/packages-indicator.component";
import {BringozCustomDataDisplayPipe} from "./pipes/bringoz-custom-data-display.pipe";
import {BringozMetaDataDisplayPipe} from "./pipes/bringoz-meta-data-display.pipe";
import {BringozCountdownComponent} from "./components/bringoz-countdown/bringoz-countdown.component";
import {BringozTimeAgoPipe} from "./pipes/bringoz-time-ago.pipe";
import {BringozVolumePipe} from "./pipes/bringoz-volume.pipe";
import {BringozWeightPipe} from "./pipes/bringoz-weight.pipe";
import {TimeWindowPipe} from "./pipes/time-window.pipe";
import {CapacityTooltipPipe} from "./pipes/capacity-tooltip.pipe";
import {
  BringozTimeWindowTooltipComponent
} from "./components/bringoz-time-window-tooltip/bringoz-time-window-tooltip.component";
import {BringozTimePipe} from "./pipes/bringoz-time.pipe";
import {BringozEtaTooltipComponent} from "./components/bringoz-eta-tooltip/bringoz-eta-tooltip.component";
import {BringozDatePipe} from "./pipes/bringoz-date.pipe";
import {TaskEtaComponent} from "./components/task-eta/task-eta.component";
import {BringozAddressPipe} from "./pipes/bringoz-address.pipe";
import {BringozAddressCityPipe} from "./pipes/bringoz-address-city.pipe";
import {TaskPurposeComponent} from "./components/task-purpose/task-purpose.component";
import {DepotLinkComponent} from "./components/depot-link/depot-link.component";
import {OmsOrderLinkComponent} from "./components/oms-order-link/oms-order-link.component";
import {PackageSpotsPipe} from "./pipes/package-spots.pipe";
import {
  EntityRelationsIndicatorComponent
} from "./components/entity-relations-indicator/entity-relations-indicator.component";
import {BringozDimensionsPipe} from "./pipes/bringoz-dimensions.pipe";
import {BringozPackageItemComponent} from "./components/bringoz-package-item/bringoz-package-item.component";
import {
  BringozPackageItemIconComponent
} from "./components/bringoz-package-item-icon/bringoz-package-item-icon.component";
import {BringozPpiDirective} from "./directives/bringoz-ppi.directive";
import {BringozCheckboxComponent} from "./components/bringoz-checkbox/bringoz-checkbox.component";
import {BringozToggleComponent} from "./components/bringoz-toggle/bringoz-toggle.component";
import {EmptyStateComponent} from "./components/empty-state/empty-state.component";
import {BringozStateLinkComponent} from "./components/bringoz-state-link/bringoz-state-link.component";
import {BringozDonutChartComponent} from "./components/bringoz-donut-chart/bringoz-donut-chart.component";
import {NgxEchartsModule} from "ngx-echarts";
import {BringozNumericWidgetComponent} from "./components/bringoz-numeric-widget/bringoz-numeric-widget.component";
import {BringozPieChartComponent} from "../components/bringoz-pie-chart/bringoz-pie-chart.component";
import {AgentLinkComponent} from "./components/agent-link/agent-link.component";
import {UserAvatarComponent} from "./components/user-avatar/user-avatar.component";
import {UserInitialsPipe} from "./pipes/user-initials.pipe";
import {LoaderComponent} from "./components/loader/loader.component";
import {
  BringozLocationDisplayComponent
} from "./components/bringoz-location-display/bringoz-location-display.component";
import {NgxPermissionsModule} from "ngx-permissions";
import {BringozTimelineLogsTableComponent} from "./components/bringoz-timeline-logs-table/bringoz-timeline-logs-table.component";
import {BringozTimelineLogsTableRowComponent} from "./components/bringoz-timeline-logs-table-row/bringoz-timeline-logs-table-row.component";
import {BringozNotesListComponent} from "./components/bringoz-notes-list/bringoz-notes-list.component";
import {ImagesLinkPopupComponent} from "./components/images-link-popup/images-link-popup.component";
import {BringozTableColumnsSettingsComponent} from "./components/bringoz-table-columns-settings/bringoz-table-columns-settings.component";
import {PackageDetailsSettingsPanelComponent} from "./components/package-details-settings-panel/package-details-settings-panel.component";
import {PackageDetailsSettingsPanelContentComponent} from "./components/package-details-settings-panel-content/package-details-settings-panel-content.component";
import {ServiceItemsTableComponent} from "./components/service-items-table/service-items-table.component";
import {BringozTimePickerComponent} from "./components/bringoz-time-picker/bringoz-time-picker.component";
import {BringozMapPipe} from "./pipes/bringoz-map.pipe";
import {CustomerLinkComponent} from "./components/customer-link/customer-link.component";
import {BringozPaginationComponent} from "./components/bringoz-pagination/bringoz-pagination.component";
import {BringozTimeConvertPipe} from "./pipes/bringoz-time-convert.pipe";
import {BringozTimeHHMMPipe} from "./pipes/bringoz-time-hhmm.pipe";
import {ServicePackageVolumeComponent} from "./components/service-package-volume/service-package-volume.component";
import {ServicePackageWeightComponent} from "./components/service-package-weight/service-package-weight.component";
import {BringozSearchInputComponent} from "./components/bringoz-search-input/bringoz-search-input.component";
import {FormsModule} from "@angular/forms";
import {BringozLabelsDisplayComponent} from "./components/bringoz-labels-display/bringoz-labels-display.component";
import {BringozCapacityBarComponent} from "./components/bringoz-capacity-bar/bringoz-capacity-bar.component";
import {TaskStatusComponent} from "./components/task-status/task-status.component";
import {RelationsIndicatorComponent} from "./components/relations-indicator/relations-indicator.component";
import {BringozCapitalizePipe} from "./pipes/bringoz-capitalize.pipe";
import {BringozFullDatePipe} from "./pipes/bringoz-full-date.pipe";
import {
  ServicePackedIndicationComponent
} from "./components/service-packed-indication/service-packed-indication.component";
import {ServicePackagesInfoComponent} from "./components/service-packages-info/service-packages-info.component";
import {BringozDateRangePipe} from "./pipes/bringoz-date-range.pipe";
import {BringozDistanceSymbolPipe} from "./pipes/bringoz-distance-symbol.pipe";
import {BringozDurationPipe} from "./pipes/bringoz-duaration.pipe";
import {BringozSpeedPipe} from "./pipes/bringoz-speed.pipe";
import {BringozDurationFormattedPipe} from "./pipes/bringoz-duration-formatted.pipe";
import {BringozDurationExactPipe} from "./pipes/bringoz-duration-exact.pipe";
import {BringozPackageCustomDataDisplayPipe} from "./pipes/bringoz-package-custom-data-display.pipe";
import {BringozPackageFieldPipe} from "./pipes/bringoz-package-field-display.pipe";
import {BringozPackagesCountPipe} from "./pipes/bringoz-package-count.pipe";
import {BringozPaddingZerosPipe} from "./pipes/bringoz-padding-zeros-display.pipe";
import {BringozPhonePrefixPipe} from "./pipes/bringoz-phone-prefix.pipe";
import {BringozPrefsPipe} from "./pipes/bringoz-prefs.pipe";
import {BringozPriceByLargeDistanceUnitPipe} from "./pipes/bringoz-price-by-large-distance-unit.pipe";
import {BringozPriceBySmallDistanceUnitPipe} from "./pipes/bringoz-price-by-small-distance-unit.pipe";
import {BringozPriceOfferPipe} from "./pipes/bringoz-price-offer.pipe";
import {BringozSpaceWordsPipe} from "./pipes/bringoz-space-words.pipe";
import {BringozTimeByNumbersPipe} from "./pipes/bringoz-time-by-numbers.pipe";
import {BringozTotalWeightPipe} from "./pipes/bringoz-total-weight.pipe";
import {CamelCaseToHumanPipe} from "./pipes/bringoz-camel-case-to-human.pipe";
import {JobPackagesVolumePipe} from "./pipes/job-packages-volume.pipe";
import {JobPackagesWeightPipe} from "./pipes/job-packages-weight.pipe";
import {KmToMetersPipe} from "./pipes/km-to-meters.pipe";
import {OmsPackagesVolumePipe} from "./pipes/oms-packages-volume.pipe";
import {OmsPackagesWeightPipe} from "./pipes/oms-packages-weight.pipe";
import {OrderSpotsPipe} from "./pipes/order-spots.pipe";
import {PackageFieldNamePipe} from "./pipes/package-field-name.pipe";
import {PackageItemValuePipe} from "./pipes/package-item-value.pipe";
import {PackageTotalValuePipe} from "./pipes/package-total-value.pipe";
import {PackageVolumePipe} from "./pipes/package-volume.pipe";
import {PackageWeightPipe} from "./pipes/package-weight.pipe";
import {PriceByMeterToSiteDistancePipe} from "./pipes/price-by-meter-to-site-distance.pipe";
import {ServicePackageVolumePipe} from "./pipes/service-package-volume.pipe";
import {ServicePackageWeightPipe} from "./pipes/service-package-weight.pipe";
import {ServiceTimePipe} from "./pipes/service-time.pipe";
import {ShortenedTextPipe} from "./pipes/shortened-text.pipe";
import {TaskSpotsPipe} from "./pipes/task-spots.pipe";
import {TaskInfoComponent} from "./components/task-info/task-info.component";
import {TaskCourierPricePipe} from "./pipes/task-courier-price.pipe";
import {
  BringozTimeZoneDisplayComponent
} from "./components/bringoz-time-zone-display/bringoz-time-zone-display.component";
import {BringozItemsLinkListComponent} from "./components/bringoz-items-link-list/bringoz-items-link-list.component";
import {RouteTotalsComponent} from "./components/route-totals/route-totals.component";
import {BringozCapacityComponent} from "./components/bringoz-capacity/bringoz-capacity.component";
import {BringozFiltersButtonComponent} from "./components/bringoz-filters-button/bringoz-filters-button.component";
import {BringozQuickFilterSelectComponent} from "./components/bringoz-quick-filter-select/bringoz-quick-filter-select.component";
import {
  BringozQuickFiltersSelectPanelComponent
} from "./components/bringoz-quick-filters-select-panel/bringoz-quick-filters-select-panel.component";
import {BringozPackagesCustomDataDisplayPipe} from "./pipes/bringoz-packages-custom-data-display.pipe";
import {
  ActivityPackedIndicationComponent
} from "./components/activity-packed-indication/activity-packed-indication.component";
import {ServicePackagesCountPipe} from "./pipes/service-packages-count.pipe";
import {BringozCircularProgressComponent} from "./components/bringoz-circular-progress/bringoz-circular-progress.component";
import {BringozLinearProgressComponent} from "./components/bringoz-linear-progress/bringoz-linear-progress.component";
import {CardSkeletonComponent} from "./components/card-skeleton/card-skeleton.component";
import {PackageTotalItemsPipe} from "./pipes/package-total-items.pipe";
import {
  BringozExpandableSearchInputComponent
} from "./components/bringoz-expandable-search-input/bringoz-expandable-search-input.component";
import {BringozTooltipDirective} from "./directives/bringoz-tooltip.directive";
import {PanelComponentComponent} from "./components/panel-component/panel-component.component";
import {OverlayModule} from "@angular/cdk/overlay";
import {BringozSelectComponent} from "./components/bringoz-select/bringoz-select.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {BringozMultiSelectComponent} from "./components/bringoz-multi-select/bringoz-multi-select.component";
import {BringozColorBoxComponent} from "./components/bringoz-color-box/bringoz-color-box.component";
import {BringozColorPickerComponent} from "./components/bringoz-color-picker/bringoz-color-picker.component";
import {BringozCountdownTimerComponent} from "./components/bringoz-countdown-timer/bringoz-countdown-timer.component";
import {
  BringozCountryCodeSelectComponent
} from "./components/bringoz-country-code-select/bringoz-country-code-select.component";
import {BatteryStatusComponent} from "./components/battery-status/battery-status.component";
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {BringozChipsComponent} from "./components/bringoz-chips/bringoz-chips.component";
import {FloatingPanelComponent} from "./components/floating-panel/floating-panel.component";
import {
  BringozFileDownloadButtonComponent
} from "./components/bringoz-file-download-button/bringoz-file-download-button.component";
import {BringozHelpButtonComponent} from "./components/bringoz-help-button/bringoz-help-button.component";
import {BringozImagesViewerComponent} from "./components/bringoz-images-viewer/bringoz-images-viewer.component";
import {
  BringozItemsLabelsTotalsComponent
} from "./components/bringoz-items-labels-totals/bringoz-items-labels-totals.component";
import {SaveFooterComponent} from "./components/save-footer/save-footer.component";
import {VolumeCapacityComponent} from "./components/volume-capacity/volume-capacity.component";
import {WeightCapacityComponent} from "./components/weight-capacity/weight-capacity.component";
import {BringozMaxLoadComponent} from "./components/bringoz-max-load/bringoz-max-load.component";
import {VehicleTypeComponent} from "./components/vehicle-type/vehicle-type.component";
import {
  BringozPrimaryCapacityComponent
} from "./components/bringoz-primary-capacity/bringoz-primary-capacity.component";
import {BringozRadioButtonComponent} from "./components/bringoz-radio-button/bringoz-radio-button.component";
import {
  BringozPackageSelectListComponent
} from "./components/bringoz-package-select-list/bringoz-package-select-list.component";
import {BringozChatButtonComponent} from "./components/bringoz-chat-button/bringoz-chat-button.component";
import {BringozDatePickerComponent} from "./components/bringoz-date-picker/bringoz-date-picker.component";
import {DocumentEditComponent} from "./components/document-edit/document-edit.component";
import {LocationToPlaceComponent} from "./components/location-to-place/location-to-place.component";
import {AttachmentPopupComponent} from "./components/attachment-popup/attachment-popup.component";
import {DeviceInfoIconComponent} from "./components/device-info-icon/device-info-icon.component";
import {ExpandButtonComponent} from "./components/expand-button/expand-button.component";
import {BringozCustomizedTableColumnsSettingsComponent} from "./components/bringoz-customized-table-columns-settings/bringoz-customized-table-columns-settings.component";
import {BringozTimeSelectComponent} from "./components/bringoz-time-select/bringoz-time-select.component";
import {BringozTimeDropdownComponent} from "./components/bringoz-time-dropdown/bringoz-time-dropdown.component";
import {
  BringozDatesTimeRangeComponent
} from "./components/bringoz-dates-time-range/bringoz-dates-time-range.component";
import {BringozDateRangePickerComponent} from "./components/bringoz-date-range-picker/bringoz-date-range-picker.component";
import {BringozDatetimeRangeComponent} from "./components/bringoz-datetime-range/bringoz-datetime-range.component";
import {BringozSiteNavToggleComponent} from "./components/bringoz-site-nav-toggle/bringoz-site-nav-toggle.component";
import {
  BringozOperationalContactsTableComponent
} from "./components/bringoz-operational-contacts-table/bringoz-operational-contacts-table.component";
import {
  BringozOperationalContactsTableRowComponent
} from "./components/bringoz-operational-contacts-table-row/bringoz-operational-contacts-table-row.component";
import {
  BringozServiceTimeInputComponent
} from "./components/bringoz-service-time-input/bringoz-service-time-input.component";
import {HighlightTextDirective} from "./directives/highlight-text.directive";
import {PackagePalletsPipe} from "./pipes/package-pallets.pipe";
import {OrderPalletsPipe} from "./pipes/order-pallets.pipe";
import {BringozDayPipe} from "./pipes/bringoz-day.pipe";
import {
  BringozDurationMinsHoursInputComponent
} from "./components/bringoz-duration-mins-hours-input/bringoz-duration-mins-hours-input.component";
import {BringozMenuPanelComponent} from "./components/bringoz-menu-panel/bringoz-menu-panel.component";
import {TaskRelationsIndicatorComponent} from "./components/task-relations-indicator/task-relations-indicator.component";
import {TaskRelationsPopupComponent} from "./components/task-relations-popup/task-relations-popup.component";
import {TableColumnPickerComponent} from "./components/table-column-picker/table-column-picker.component";
import {TableColumnInsertButtonComponent} from "./components/table-column-insert-button/table-column-insert-button.component";

declare const moment: any;

@NgModule({
  declarations: [
    BringozTooltipComponent,
    ExpandButtonComponent,
    BringozDatetimeRangeComponent,
    BringozCustomizedTableColumnsSettingsComponent,
    BringozPhonePipe,
    TextCopyButtonComponent,
    BranchesIndicatorComponent,
    PermissionDirective,
    TableColumnManagerDirective,
    TableScrollSyncDirective,
    TableHeaderDefDirective,
    TableRowDefDirective,
    BringozDataTableComponent,
    BringozButtonComponent,
    BringozLabelsDisplayComponent,
    BringozIconComponent,
    BringozCapacityBarComponent,
    BringozPrimaryCapacityComponent,
    BringozOperationalContactsTableComponent,
    BringozOperationalContactsTableRowComponent,
    BringozCircularProgressComponent,
    BringozLinearProgressComponent,
    CardSkeletonComponent,
    BringozSwitchComponent,
    BringozStatusTagComponent,
    BringozItemsListDisplayComponent,
    BringozIdGeneratorDirective,
    BringozDurationMinsHoursInputComponent,
    BringozPricePipe,
    BringozDistancePipe,
    BringozTemperaturePipe,
    BringozTagsComponent,
    BringozTagComponent,
    UserNamePipe,
    SkillTagsComponent,
    BringozPackagesItemsDisplayListComponent,
    PackagesIndicatorComponent,
    BringozCustomDataDisplayPipe,
    BringozMetaDataDisplayPipe,
    BringozCountdownComponent,
    BringozTimeAgoPipe,
    BringozVolumePipe,
    BringozWeightPipe,
    TimeWindowPipe,
    CapacityTooltipPipe,
    BringozTimeWindowTooltipComponent,
    BringozTimePipe,
    BringozEtaTooltipComponent,
    BringozDatePipe,
    TaskEtaComponent,
    BringozAddressPipe,
    BringozAddressCityPipe,
    BringozDateRangePipe,
    ServicePackageWeightPipe,
    BringozDistanceSymbolPipe,
    JobPackagesWeightPipe,
    BringozPrefsPipe,
    JobPackagesVolumePipe,
    CamelCaseToHumanPipe,
    BringozTimeByNumbersPipe,
    ServicePackageVolumePipe,
    PriceByMeterToSiteDistancePipe,
    BringozPhonePrefixPipe,
    OmsPackagesVolumePipe,
    OmsPackagesWeightPipe,
    BringozPackagesCountPipe,
    BringozPackageFieldPipe,
    BringozDurationFormattedPipe,
    BringozDurationExactPipe,
    PackageFieldNamePipe,
    PackageVolumePipe,
    BringozPaddingZerosPipe,
    BringozPriceOfferPipe,
    BringozDurationPipe,
    BringozSpeedPipe,
    OrderSpotsPipe,
    OrderPalletsPipe,
    BringozPackageCustomDataDisplayPipe,
    PackageTotalValuePipe,
    PackageTotalItemsPipe,
    ShortenedTextPipe,
    BringozSpaceWordsPipe,
    BringozPriceByLargeDistanceUnitPipe,
    KmToMetersPipe,
    ServiceTimePipe,
    PackageItemValuePipe,
    BringozPriceBySmallDistanceUnitPipe,
    PackageWeightPipe,
    TaskSpotsPipe,
    BringozTotalWeightPipe,
    TaskPurposeComponent,
    TaskStatusComponent,
    DepotLinkComponent,
    OmsOrderLinkComponent,
    PackageSpotsPipe,
    PackagePalletsPipe,
    EntityRelationsIndicatorComponent,
    BringozDimensionsPipe,
    BringozPackageItemComponent,
    BringozPackageItemIconComponent,
    BringozPpiDirective,
    BringozTooltipDirective,
    BringozCheckboxComponent,
    BringozToggleComponent,
    EmptyStateComponent,
    BringozStateLinkComponent,
    BringozDonutChartComponent,
    BringozNumericWidgetComponent,
    AgentLinkComponent,
    UserAvatarComponent,
    UserInitialsPipe,
    LoaderComponent,
    BringozLocationDisplayComponent,
    BringozMapPipe,
    CustomerLinkComponent,
    BringozPaginationComponent,
    BringozTimeConvertPipe,
    BringozTimeHHMMPipe,
    ServicePackageVolumeComponent,
    ServicePackageWeightComponent,
    BringozSearchInputComponent,
    RelationsIndicatorComponent,
    BringozCapitalizePipe,
    BringozFullDatePipe,
    ServicePackedIndicationComponent,
    ServicePackagesInfoComponent,
    TaskInfoComponent,
    TaskCourierPricePipe,
    BringozTimeZoneDisplayComponent,
    BringozItemsLinkListComponent,
    RouteTotalsComponent,
    BringozCapacityComponent,
    BringozFiltersButtonComponent,
    BringozQuickFilterSelectComponent,
    BringozQuickFiltersSelectPanelComponent,
    BringozPackagesCustomDataDisplayPipe,
    ActivityPackedIndicationComponent,
    ServicePackagesCountPipe,
    BringozExpandableSearchInputComponent,
    PanelComponentComponent,
    BringozSelectComponent,
    BringozMultiSelectComponent,
    BatteryStatusComponent,
    BringozChipsComponent,
    BringozColorBoxComponent,
    BringozColorPickerComponent,
    BringozCountdownTimerComponent,
    BringozCountryCodeSelectComponent,
    BringozFileDownloadButtonComponent,
    BringozHelpButtonComponent,
    BringozImagesViewerComponent,
    BringozItemsLabelsTotalsComponent,
    SaveFooterComponent,
    VolumeCapacityComponent,
    WeightCapacityComponent,
    BringozMaxLoadComponent,
    VehicleTypeComponent,
    BringozRadioButtonComponent,
    BringozPackageSelectListComponent,
    BringozChatButtonComponent,
    BringozDatePickerComponent,
    BringozDateRangePickerComponent,
    DeviceInfoIconComponent,
    DocumentEditComponent,
    LocationToPlaceComponent,
    AttachmentPopupComponent,
    BringozTimeSelectComponent,
    BringozTimeDropdownComponent,
    BringozDatesTimeRangeComponent,
    BringozSiteNavToggleComponent,
    BringozServiceTimeInputComponent,
    HighlightTextDirective,
    BringozDayPipe,
    BringozMenuPanelComponent,
    FloatingPanelComponent,
    TaskRelationsIndicatorComponent,
    TaskRelationsPopupComponent,
    BringozTimelineLogsTableComponent,
    BringozTimelineLogsTableRowComponent,
    BringozNotesListComponent,
    ImagesLinkPopupComponent,
    BringozTableColumnsSettingsComponent,
    PackageDetailsSettingsPanelComponent,
    PackageDetailsSettingsPanelContentComponent,
    ServiceItemsTableComponent,
    BringozTimePickerComponent,
    TableColumnPickerComponent,
    TableColumnInsertButtonComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    NgbModule,
    FormsModule,
    AngularSvgIconModule,
    TranslateModule.forChild(),
    NgxEchartsModule.forChild(),
    NgxPermissionsModule.forChild(),
    FormsModule,
    NgSelectModule,
    CdkVirtualForOf,
    CdkFixedSizeVirtualScroll,
    CdkVirtualScrollViewport,
    DragDropModule,
    BzButton,
    BzCard,
    BzDatePicker,
    BzDivider,
    BzEmptyState,
    BzIcon,
    BzRadio,
    BzRadioGroup,
    BzSearchInput,
    BzSelect,
    BzSpinner,
    BzSwitch,
    BzTable,
    BzTableHeaderDef,
    BzTableRowDef,
    BzTag,
    BzTooltip
  ],
  providers: [
    CurrencyPipe,
    BringozTimeAgoPipe,
    BringozWeightPipe,
    BringozVolumePipe,
    {
      provide: 'moment',
      useValue: moment
    }
  ],
  exports: [
    BringozTimePickerComponent,
    BringozTimelineLogsTableComponent,
    BringozNotesListComponent,
    ServiceItemsTableComponent,
    DeviceInfoIconComponent,
    LocationToPlaceComponent,
    AttachmentPopupComponent,
    ExpandButtonComponent,
    BringozCustomizedTableColumnsSettingsComponent,
    BringozDatePickerComponent,
    BringozSiteNavToggleComponent,
    BringozDateRangePickerComponent,
    BringozTimeSelectComponent,
    BringozTimeDropdownComponent,
    BringozDatesTimeRangeComponent,
    BringozDatetimeRangeComponent,
    DocumentEditComponent,
    BringozTooltipComponent,
    BringozPhonePipe,
    TextCopyButtonComponent,
    BranchesIndicatorComponent,
    PermissionDirective,
    TableColumnManagerDirective,
    TableScrollSyncDirective,
    TableHeaderDefDirective,
    TableRowDefDirective,
    BringozDataTableComponent,
    BringozButtonComponent,
    BringozSwitchComponent,
    BringozIconComponent,
    BringozCapacityBarComponent,
    BringozPrimaryCapacityComponent,
    BringozOperationalContactsTableComponent,
    BringozOperationalContactsTableRowComponent,
    BringozCircularProgressComponent,
    BringozLinearProgressComponent,
    CardSkeletonComponent,
    BringozStatusTagComponent,
    BringozItemsListDisplayComponent,
    BringozIdGeneratorDirective,
    BringozPricePipe,
    BringozDistancePipe,
    BringozTemperaturePipe,
    BringozTagsComponent,
    BringozTagComponent,
    UserNamePipe,
    SkillTagsComponent,
    BringozPackagesItemsDisplayListComponent,
    PackagesIndicatorComponent,
    BringozCustomDataDisplayPipe,
    BringozMetaDataDisplayPipe,
    BringozCountdownComponent,
    BringozTimeAgoPipe,
    BringozVolumePipe,
    BringozWeightPipe,
    TimeWindowPipe,
    CapacityTooltipPipe,
    BringozTimeWindowTooltipComponent,
    BringozTimePipe,
    BringozEtaTooltipComponent,
    BringozDatePipe,
    TaskEtaComponent,
    BringozAddressPipe,
    BringozAddressCityPipe,
    BringozDateRangePipe,
    BringozDistanceSymbolPipe,
    ShortenedTextPipe,
    CamelCaseToHumanPipe,
    OrderSpotsPipe,
    OrderPalletsPipe,
    JobPackagesVolumePipe,
    TaskSpotsPipe,
    OmsPackagesVolumePipe,
    OmsPackagesWeightPipe,
    JobPackagesWeightPipe,
    ServicePackageVolumePipe,
    BringozTotalWeightPipe,
    KmToMetersPipe,
    BringozTimeByNumbersPipe,
    BringozSpaceWordsPipe,
    BringozPriceBySmallDistanceUnitPipe,
    BringozPriceOfferPipe,
    PriceByMeterToSiteDistancePipe,
    BringozPhonePrefixPipe,
    ServicePackageWeightPipe,
    BringozPrefsPipe,
    ServiceTimePipe,
    BringozPaddingZerosPipe,
    BringozPackageFieldPipe,
    BringozDurationFormattedPipe,
    BringozDurationExactPipe,
    PackageItemValuePipe,
    PackageFieldNamePipe,
    PackageTotalValuePipe,
    PackageTotalItemsPipe,
    BringozDurationPipe,
    BringozSpeedPipe,
    BringozPackagesCountPipe,
    PackageVolumePipe,
    BringozPackageCustomDataDisplayPipe,
    PackageWeightPipe,
    BringozPriceByLargeDistanceUnitPipe,
    TaskPurposeComponent,
    TaskStatusComponent,
    DepotLinkComponent,
    OmsOrderLinkComponent,
    PackageSpotsPipe,
    PackagePalletsPipe,
    EntityRelationsIndicatorComponent,
    BringozDimensionsPipe,
    BringozPackageItemComponent,
    BringozPackageItemIconComponent,
    BringozPpiDirective,
    BringozTooltipDirective,
    BringozCheckboxComponent,
    BringozToggleComponent,
    EmptyStateComponent,
    BringozStateLinkComponent,
    BringozDonutChartComponent,
    BringozNumericWidgetComponent,
    AgentLinkComponent,
    UserAvatarComponent,
    UserInitialsPipe,
    LoaderComponent,
    BringozLocationDisplayComponent,
    BringozMapPipe,
    CustomerLinkComponent,
    BringozPaginationComponent,
    BringozTimeConvertPipe,
    BringozTimeHHMMPipe,
    ServicePackageVolumeComponent,
    ServicePackageWeightComponent,
    BringozSearchInputComponent,
    BringozLabelsDisplayComponent,
    RelationsIndicatorComponent,
    BringozCapitalizePipe,
    BringozFullDatePipe,
    ServicePackedIndicationComponent,
    ServicePackagesInfoComponent,
    TaskInfoComponent,
    TaskCourierPricePipe,
    BringozTimeZoneDisplayComponent,
    BringozItemsLinkListComponent,
    RouteTotalsComponent,
    BringozCapacityComponent,
    BringozDurationMinsHoursInputComponent,
    BringozFiltersButtonComponent,
    BringozQuickFilterSelectComponent,
    BringozPackagesCustomDataDisplayPipe,
    ActivityPackedIndicationComponent,
    ServicePackagesCountPipe,
    BringozExpandableSearchInputComponent,
    PanelComponentComponent,
    BringozSelectComponent,
    BringozMultiSelectComponent,
    BatteryStatusComponent,
    BringozChipsComponent,
    BringozColorBoxComponent,
    BringozColorPickerComponent,
    BringozCountdownTimerComponent,
    BringozCountryCodeSelectComponent,
    BringozFileDownloadButtonComponent,
    BringozHelpButtonComponent,
    BringozImagesViewerComponent,
    BringozItemsLabelsTotalsComponent,
    SaveFooterComponent,
    VolumeCapacityComponent,
    WeightCapacityComponent,
    BringozMaxLoadComponent,
    VehicleTypeComponent,
    BringozRadioButtonComponent,
    BringozPackageSelectListComponent,
    BringozChatButtonComponent,
    BringozServiceTimeInputComponent,
    HighlightTextDirective,
    BringozDayPipe,
    BringozMenuPanelComponent,
    FloatingPanelComponent,
    TaskRelationsIndicatorComponent,
    TaskRelationsPopupComponent,
    TableColumnInsertButtonComponent
  ]
})

export class CommonsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapCommonsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(CommonsModule);
};

export const downgradedCommonsModule = downgradeModule(bootstrapCommonsModule);
